import React, { useEffect } from 'react';
import pushGTMWithDelay from 'utils/pushGTMWithDelay';
import { pushGTMBookingFormDisplayedEvent, types } from 'utils/gtm';
import { getCurrentDate, getDaysBetween } from 'utils/date';
import useSelector, { useDispatch } from 'components/Booking-new/hooks';
import { getFormattedDateTime } from 'utils/momentHelpers';
import stepTypes from 'components/Booking-new/modules/Steps/types';
import leadService from 'services/LeadService';
import { getServiceCode, getServiceData } from 'components/Booking-new/utils/steps/service';
import {
  saveLeadDataAndPushGTM,
  checkDuplicateBookingAndPushGTM,
} from 'components/Booking-new/utils/steps/bookingform';

const PersonalDataContainer = (Component, { data, navigation }) => {
  const dispatch = useDispatch();
  const { results } = useSelector(state => ({
    activeStep: state?.activeStep || 0,
    freeParking: state?.config?.freeParking,
    showNewsBanner: state?.config?.showNewsBanner,
    stepLocationData: state?.userData[stepTypes.location]?.selectedLocation,
    stepTimeData: state?.userData[stepTypes.time],
    stepPersonalData: state?.userData[stepTypes.personalData],
    rescheduleData: state?.userData[stepTypes.reschedule]?.appointment?.appointmentid,
    serviceData:
      getServiceData(state?.services.nodes, state?.userData[stepTypes.reschedule]?.service.service) ||
      state?.config?.service,
    serviceLogin: state?.config?.service,
    serviceCode: getServiceCode(state?.userData[stepTypes.reschedule]?.service.service, state?.config?.service?.code),
    selectedCity: state?.selectedCity,
    locations: state?.locations,
    allServices: state?.services,
    funnelType: state?.config?.funnelType,
    allSteps: state?.allSteps,
  }));

  const trustInfo = {
    trustedBy: data?.trustedBy,
    maxScore: data?.maxScore,
    score: data?.score,
    trustLogo: data?.trustLogo,
    performanceStatement: data?.performanceStatement,
    trustedListItems: data?.trustedListItems,
    showBookingRatingWidget: data?.showBookingRatingWidget,
  };

  const {
    stepLocationData,
    stepTimeData,
    stepPersonalData,
    freeParking,
    showNewsBanner,
    locations,
    selectedCity,
    serviceCode,
    serviceData,
    funnelType,
  } = results;

  const [sdate, stime] = getFormattedDateTime(stepTimeData?.time);

  const savePersonalData = async (formData, leadAdditionalData, selectedCity = null) =>
    saveLeadDataAndPushGTM(
      data?.shouldCreateLead,
      results,
      navigation,
      dispatch,
      formData,
      leadAdditionalData,
      selectedCity,
    );

  const checkDuplicateBooking = async formData => await checkDuplicateBookingAndPushGTM(formData, serviceCode);

  useEffect(() => {
    if (data?.shouldCreateLead)
      // Requesting lead token only if creating lead is enabled from contentful.
      leadService.getLeadToken();

    const currentDate = getCurrentDate();
    const daysBetween = getDaysBetween(currentDate, sdate);
    const eventBody = {
      location: stepLocationData?.code,
      hourOfDay: stime,
      selectedDate: sdate,
      currentDate,
      daysBetween: `${daysBetween}`,
      type: results?.rescheduleData ? types.reschedule : types.book,
      service: serviceCode,
      funnelType,
    };

    // trigger GTM event "Booking Form Displayed"
    pushGTMWithDelay(33, pushGTMBookingFormDisplayedEvent, eventBody);
  }, []);

  return (
    <Component
      serviceLogin={results?.serviceLogin}
      data={data}
      sdate={sdate}
      stime={stime}
      locations={locations}
      freeParking={freeParking}
      service={serviceData}
      stepTimeData={stepTimeData}
      stepLocationData={stepLocationData}
      stepPersonalData={stepPersonalData}
      rescheduleData={results?.rescheduleData}
      selectedCity={selectedCity}
      showNewsBanner={showNewsBanner}
      checkDuplicateBooking={checkDuplicateBooking}
      savePersonalData={savePersonalData}
      trustInfo={trustInfo}
    />
  );
};

export default PersonalDataContainer;
